import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getNewToken } from './authApi';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: 'https://api.doramahype.ru/api/v1',
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.accessToken;
    if (token) headers.set('Authorization', `Bearer ${token}`);
    return headers;
  },
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    try {
      // getNewToken() централизованно управляет очередью — только один HTTP запрос на refresh
      await getNewToken();
      // Redux уже обновлён внутри getNewToken, повторяем запрос с новым токеном
      result = await rawBaseQuery(args, api, extraOptions);
    } catch {
      // logout уже вызван внутри getNewToken при ошибке
    }
  }

  return result;
};
